import React from 'react';
import { STOCK_STATUSES } from '/src/consts';
import * as styles from './styles.scss';

const ProductVariantsWrapper = ({ className, children }) => (
    <div className={`${styles.wrapper}${className ? ` ${className}` : ''}`}>
        {children}
    </div>
);

const ProductVariant = ({
    attributes = [],
    product: {
        stock_status,
        display_weight,
        price_range: {
            minimum_price: {
                discount: { percent_off } = {},
            } = {},
        } = {},
    },
    isActive,
    handleClick,
}) => {
    const { label } = attributes?.find(({ value_index }) => value_index === display_weight ) || {};

    return (
        <button
            className={`${styles.variant}${isActive ? ` ${styles.active}` : ''}`}
            onClick={!isActive ? handleClick : undefined}
            disabled={stock_status !== STOCK_STATUSES.IN_STOCK}
        >
            <div className={styles.label}>
                {label}
            </div>
            {
                !!percent_off &&
                <div className={styles.discount}>
                    {percent_off}%
                </div>
            }
        </button>
    );
};

export default ProductVariant;
export {
    ProductVariantsWrapper
}
